export class Sliderlogo {

	constructor( options ) {
		this.options = options
		this.logo = $( '.logo' )
	}

	init() {
		const logo = this.logo

		if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) ) {
			logo.slick( {
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false,
				dots: false,
			} )
		}
	}
}


// WEBPACK FOOTER //
// ./scripts/components/slider-logo.js